/* eslint-disable sort-imports */
import ContentSet from './content-set';
import Data from 'app/components/partials/data';
import Faq from './faq';
import FileDownload from './file-download';
import FileGroup from './file-group';
import HeroCarousel from './hero-carousel';
import ImageGallery from './image-gallery';
import Jotform from './jotform';
import JsonLd from 'app/components/partials/json-ld';
import NewsletterSignup from './newsletter-signup';
import PagebreakQuote from './pagebreak-quote';
import ParkingAvailability from './parking-availability';
import PropTypes from 'prop-types';
import React from 'react';
import Review from './review';
import StacklaWidget from './stackla-widget';
import TextContent from './text-content';
import Treble from './treble';
import Video from './video';
import VirtualTour from './virtual-tour';
import { getContentBlocksStructuredData } from 'app/utilities/seo';

class ContentBlocks extends React.Component {
    constructor(props) {
        super(props);
    }

    renderBlock(block, index) {
        const { isLarge, pageTitle } = this.props;

        switch (block.type) {
            case 'carousel':
                return <HeroCarousel key={index} data={block.data} pageTitle={pageTitle} />;
            case 'content':
            case 'contentaside':
            case 'contentquote':
                return <TextContent key={index} {...block.data} />;
            case 'crosspromo':
            case 'contentset':
                return <ContentSet key={index} {...block} isLarge={isLarge} />;
            case 'faq':
                return <Faq key={index} data={block.data} />;
            case 'file':
                return <FileDownload key={index} {...block.data} />;
            case 'filegroup':
                return <FileGroup key={index} {...block.data} />;
            case 'gallery':
                return <ImageGallery key={index} data={block.data} pageTitle={pageTitle} />;
            case 'jotform':
                return <Jotform key={index} {...block.data} />;
            case 'newslettersignup':
                return <NewsletterSignup key={index} data={block.data} isLarge={isLarge} pageTitle={pageTitle} />;
            case 'parkingavailability':
                return <ParkingAvailability key={index} />;
            case 'pagebreakquote':
                return <PagebreakQuote key={index} {...block.data} />;
            case 'treble':
                return <Treble key={index} {...block.data} isLarge={isLarge} />;
            case 'review':
                return <Review key={index} data={block.data} />;
            case 'stackla':
                return <StacklaWidget key={index} {...block.data} />;
            case 'video':
                return <Video key={index} {...block.data} />;
            case 'virtualtour':
                return <VirtualTour key={index} {...block.data} />;
            default:
                return (
                    <Data key={index} title={`Missing content block type: ${block.type}`} />
                );
        }
    }

    render() {
        const { data, pageTitle, pageUrl } = this.props;

        if (!data.length) {
            return null;
        }

        return (
            <div className="content-blocks">
                <JsonLd data={getContentBlocksStructuredData(data, { title: pageTitle, url: pageUrl })} />
                {data.map((data, index) => {
                    return this.renderBlock(data, index);
                })}
            </div>
        );
    }
}

ContentBlocks.propTypes = {
    data: PropTypes.array.isRequired,
    isLarge: PropTypes.bool,
    pageTitle: PropTypes.string,
    pageUrl: PropTypes.string
};

ContentBlocks.defaultProps = {
    isLarge: false,
    pageTitle: ''
};

export default ContentBlocks;
